/* tslint:disable */
/* eslint-disable */
/**
 * GateHouse AIS GPS lost detection api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Modelling a date time range
 * @export
 * @interface DateTimeRangeSchema
 */
export interface DateTimeRangeSchema {
    /**
     * time range lower/beginning
     * @type {any}
     * @memberof DateTimeRangeSchema
     */
    lower?: any | null;
    /**
     * time range upper/ending
     * @type {any}
     * @memberof DateTimeRangeSchema
     */
    upper?: any | null;
}

/**
 * Check if a given object implements the DateTimeRangeSchema interface.
 */
export function instanceOfDateTimeRangeSchema(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DateTimeRangeSchemaFromJSON(json: any): DateTimeRangeSchema {
    return DateTimeRangeSchemaFromJSONTyped(json, false);
}

export function DateTimeRangeSchemaFromJSONTyped(json: any, ignoreDiscriminator: boolean): DateTimeRangeSchema {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'lower': !exists(json, 'lower') ? undefined : json['lower'],
        'upper': !exists(json, 'upper') ? undefined : json['upper'],
    };
}

export function DateTimeRangeSchemaToJSON(value?: DateTimeRangeSchema | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'lower': value.lower,
        'upper': value.upper,
    };
}

